module.exports = __webpack_public_path__ + "img/Greenbars-SSL-enhanced_validation_certificates-766x318.df02f6bb.png";